import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LucideAngularModule, Check } from 'lucide-angular';
import { NgOptimizedImage } from '@angular/common';

@Component({
  standalone: true,
  selector: 'ef-studio-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, LucideAngularModule, NgOptimizedImage],
  template: `<div
    class="md:h-full max-w-[600px] mx-auto lg:w-[600px] aspect-[347/450] bg-[url(assets/empikfoto/images/studio_banner_background.jpg)] bg-cover bg-top md:bg-center flex flex-col justify-between"
  >
    <div class="flex flex-col justify-center px-4 md:p-6">
      <div class="flex justify-center">
        <img
          ngSrc="empikfoto/images/logo-ef-studio.png"
          alt="Empik Foto Studio"
          class="!h-auto pt-6 md:pt-10 pb-4 md:pb-10"
          width="147"
          height="50"
        />
      </div>
      <div class="flex flex-col gap-4 mx-auto">
        <p class="text-heading-05 md:text-heading-04 text-black">{{ 'studio_banner_header_text' | translate }}</p>
        <ul class="space-y-3">
          <li class="flex items-start gap-3">
            <lucide-icon [img]="Check" class="w-5 h-5 text-primary flex-shrink-0 mt-0.5"></lucide-icon>
            <span class="text-body-02 text-black">{{ 'studio_banner_benefit_1' | translate }}</span>
          </li>
          <li class="flex items-start gap-3">
            <lucide-icon [img]="Check" class="w-5 h-5 text-primary flex-shrink-0 mt-0.5"></lucide-icon>
            <span class="text-body-02 text-black">{{ 'studio_banner_benefit_2' | translate }}</span>
          </li>
          <li class="flex items-start gap-3">
            <lucide-icon [img]="Check" class="w-5 h-5 text-primary flex-shrink-0 mt-0.5"></lucide-icon>
            <span class="text-body-02 text-black">{{ 'studio_banner_benefit_3' | translate }}</span>
          </li>
          <li class="flex items-start gap-3">
            <lucide-icon [img]="Check" class="w-5 h-5 text-primary flex-shrink-0 mt-0.5"></lucide-icon>
            <span class="text-body-02 text-black">{{ 'studio_banner_benefit_4' | translate }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>`,
})
export class EfStudioBannerComponent {
  readonly Check = Check;
}
